export default function getDatasetNamesFromSpec(a) {
  var b = a.data;

  if (b) {
    if (Array.isArray(b)) // Array of data
      return b.map(function (a) {
        var b = a.name;
        return b;
      });
    if ("string" == typeof b.name) // Single data
      return [b.name];
  }

  return [];
}